"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.marketingAttributionEntityResponseSchema = exports.marketingAttributionEntityQuerySchema = exports.marketingFunnelResponseSchema = exports.marketingFunnelRowSchema = exports.marketingFunnelQuerySchema = exports.marketingAttributionDiagnosticsResponseSchema = exports.marketingAttributionDiagnosticSchema = exports.updateMarketingAttributionSettingsRequestSchema = exports.marketingAttributionSettingsSchema = exports.googleConversionMappingSchema = exports.googleConversionDeliveryStatusSchema = exports.googleConversionConnectionStatusSchema = exports.googleConversionModeSchema = exports.googleConversionKindSchema = exports.marketingAttributionSummarySchema = exports.marketingAttributionTouchSchema = exports.marketingAttributionConsentSchema = void 0;
const zod_1 = require("zod");
const nullableBounded = (maximum) => zod_1.z.string().trim().max(maximum).nullable().default(null);
const attributionSourceKeySchema = zod_1.z
    .string()
    .trim()
    .min(2)
    .max(80)
    .regex(/^[a-z0-9]+(?:[._-][a-z0-9]+)*$/);
const attributionSourceCategorySchema = zod_1.z.enum([
    "DIRECT",
    "REFERRAL",
    "ORGANIC",
    "PAID",
    "MARKETPLACE",
    "PARTNER",
    "OFFLINE",
    "OTHER",
]);
exports.marketingAttributionConsentSchema = zod_1.z.enum([
    "GRANTED",
    "DENIED",
    "UNSPECIFIED",
]);
exports.marketingAttributionTouchSchema = zod_1.z.object({
    capturedAt: zod_1.z.string().datetime({ offset: true }),
    landingPath: nullableBounded(500),
    referrer: zod_1.z.string().trim().url().max(2_048).nullable().default(null),
    gclid: nullableBounded(200),
    gbraid: nullableBounded(200),
    wbraid: nullableBounded(200),
    utmSource: nullableBounded(120),
    utmMedium: nullableBounded(120),
    utmCampaign: nullableBounded(160),
    utmTerm: nullableBounded(160),
    utmContent: nullableBounded(160),
});
/** Safe for office and field surfaces; raw click identifiers are excluded. */
exports.marketingAttributionSummarySchema = zod_1.z.object({
    sourceKey: attributionSourceKeySchema,
    sourceName: zod_1.z.string().trim().min(1).max(120),
    category: attributionSourceCategorySchema,
    channelKey: zod_1.z.string().trim().max(80).nullable(),
    firstCapturedAt: zod_1.z.string().datetime({ offset: true }),
    lastCapturedAt: zod_1.z.string().datetime({ offset: true }),
    campaign: zod_1.z.string().trim().max(160).nullable(),
    medium: zod_1.z.string().trim().max(120).nullable(),
    source: zod_1.z.string().trim().max(120).nullable(),
    consent: exports.marketingAttributionConsentSchema,
});
exports.googleConversionKindSchema = zod_1.z.enum([
    "BOOKED",
    "COMPLETED",
    "PAID",
]);
exports.googleConversionModeSchema = zod_1.z.enum(["SANDBOX", "LIVE"]);
exports.googleConversionConnectionStatusSchema = zod_1.z.enum([
    "DISABLED",
    "SANDBOX_READY",
    "LIVE_ACCESS_REQUIRED",
    "HEALTHY",
    "NEEDS_ATTENTION",
]);
exports.googleConversionDeliveryStatusSchema = zod_1.z.enum([
    "PENDING",
    "SUCCEEDED",
    "RETRYING",
    "FAILED",
    "SKIPPED_NO_CONSENT",
    "SKIPPED_NO_CLICK_ID",
    "SKIPPED_NOT_MAPPED",
]);
exports.googleConversionMappingSchema = zod_1.z.object({
    kind: exports.googleConversionKindSchema,
    enabled: zod_1.z.boolean(),
    conversionAction: zod_1.z.string().trim().max(240).nullable(),
});
exports.marketingAttributionSettingsSchema = zod_1.z.object({
    enabled: zod_1.z.boolean(),
    mode: exports.googleConversionModeSchema,
    googleAdsCustomerId: zod_1.z
        .string()
        .trim()
        .regex(/^\d{10}$/)
        .nullable(),
    retentionDays: zod_1.z.number().int().min(30).max(730),
    mappings: zod_1.z.array(exports.googleConversionMappingSchema).length(3),
    connectionStatus: exports.googleConversionConnectionStatusSchema,
    updatedAt: zod_1.z.string().datetime({ offset: true }),
});
exports.updateMarketingAttributionSettingsRequestSchema = zod_1.z.object({
    enabled: zod_1.z.boolean(),
    mode: exports.googleConversionModeSchema,
    googleAdsCustomerId: zod_1.z
        .string()
        .trim()
        .regex(/^\d{10}$/)
        .nullable(),
    retentionDays: zod_1.z.number().int().min(30).max(730),
    mappings: zod_1.z.array(exports.googleConversionMappingSchema).length(3),
});
exports.marketingAttributionDiagnosticSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    kind: exports.googleConversionKindSchema,
    status: exports.googleConversionDeliveryStatusSchema,
    entityType: zod_1.z.enum(["LEAD", "JOB", "INVOICE"]),
    entityId: zod_1.z.string().uuid(),
    attempts: zod_1.z.number().int().nonnegative(),
    safeErrorCode: zod_1.z.string().max(80).nullable(),
    safeErrorMessage: zod_1.z.string().max(500).nullable(),
    nextAttemptAt: zod_1.z.string().datetime({ offset: true }).nullable(),
    updatedAt: zod_1.z.string().datetime({ offset: true }),
});
exports.marketingAttributionDiagnosticsResponseSchema = zod_1.z.object({
    settings: exports.marketingAttributionSettingsSchema,
    totals: zod_1.z.object({
        pending: zod_1.z.number().int().nonnegative(),
        succeeded: zod_1.z.number().int().nonnegative(),
        retrying: zod_1.z.number().int().nonnegative(),
        failed: zod_1.z.number().int().nonnegative(),
        skipped: zod_1.z.number().int().nonnegative(),
    }),
    recent: zod_1.z.array(exports.marketingAttributionDiagnosticSchema),
});
exports.marketingFunnelQuerySchema = zod_1.z.object({
    from: zod_1.z.string().datetime({ offset: true }).optional(),
    to: zod_1.z.string().datetime({ offset: true }).optional(),
});
exports.marketingFunnelRowSchema = zod_1.z.object({
    sourceKey: attributionSourceKeySchema,
    sourceName: zod_1.z.string().trim().min(1).max(120),
    campaign: zod_1.z.string().trim().max(160).nullable(),
    leads: zod_1.z.number().int().nonnegative(),
    bookings: zod_1.z.number().int().nonnegative(),
    completedJobs: zod_1.z.number().int().nonnegative(),
    paidInvoices: zod_1.z.number().int().nonnegative(),
    paidRevenueCents: zod_1.z.number().int().nonnegative(),
});
exports.marketingFunnelResponseSchema = zod_1.z.object({
    generatedAt: zod_1.z.string().datetime({ offset: true }),
    rows: zod_1.z.array(exports.marketingFunnelRowSchema),
});
exports.marketingAttributionEntityQuerySchema = zod_1.z.object({
    targetType: zod_1.z.enum([
        "LEAD",
        "CUSTOMER",
        "JOB",
        "ESTIMATE",
        "BOOKING",
        "INVOICE",
        "PAYMENT",
    ]),
    targetId: zod_1.z.string().uuid(),
});
exports.marketingAttributionEntityResponseSchema = zod_1.z.object({
    attribution: exports.marketingAttributionSummarySchema.nullable(),
});
//# sourceMappingURL=marketing-attribution.js.map